// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2sahS","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2krxF"};